export const SmcButtonContent = {
  templates: {
    inheritance: {
      heading: 'What would you like to do?',
      sections: [
        {
          smcTemplateKey: 'inheritanceDigitalPath',
          smcMsg: 'Send link to this digital path to the client/beneficiary',
          smcButton: 'Send link',
        },
        {
          smcTemplateKey: 'inheritanceMissingDeathCert',
          smcMsg: 'Send a message to the client/beneficiary requesting a death certificate',
          smcButton: 'Send message',
        },
      ],
    },
    gifting: {
      sections: [
        {
          smcTemplateKey: 'giftingDigitalPath',
          smcMsg: 'Send a message to the client including a link to our digital gifting flow',
          smcButton: 'Send Message',
        },
      ],
    },
    internalTransfer: {
      sections: [
        {
          smcTemplateKey: 'internalTransferDigitalPath',
          smcMsg:
            'Send a message to the client including a link to our digital internal transfer flow',
          smcButton: 'Send Message',
        },
      ],
    },
  },
  thankYou: {
    description: 'THANK YOU!  A link has been sent through the Secure Message Center',
    smcLink: '/us/KeyClientData',
    smcLinkLabel: 'Go to key client data page',
  },
};
